<template>
  <div class="flex flex-col gap-6 text-ui-md font-ui">
    <p>
      Unter dem Dach der Bauer Media Group entstehen Tag für Tag Produkte, die Millionen von Menschen quer durch Europa begeistern. Unser Portfolio reicht dabei von Print- und Online-Publikationen über Audio-Entertainment bis hin zu Online-Vergleichsportale.
    </p>
    <p>© 2025 Bauer Media Group</p>
  </div>
</template>
